import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_Staff_DigitalID } from "../shared/data.service";
import { StaffRegisterManualEmailRequest } from "../shared/StaffRegisterManualEmailRequest";
import { StaffDigitalIdBatchImportTableComponent } from "./staff-digital-id-batch-import-table/staff-digital-id-batch-import-table.component";
import { StaffDigitalIdBatchImportComponent } from "./staff-digital-id-batch-import/staff-digital-id-batch-import.component";
import { StaffDigitalIdDownloadComponent } from "./staff-digital-id-download/staff-digital-id-download.component";
import { StaffExportDigitalIdComponent } from "./staff-export-digital-id/staff-export-digital-id.component";
import { DigitalIdActivationInfoComponent } from "../digital-id-activation-info/digital-id-activation-info.component";
import { CheckValidActivationsRequest } from "../shared/CheckValidActivationsRequest";

@Component({
	selector: "caass-staff-digital-id-batch-mode",
	templateUrl: "./staff-digital-id-batch-mode.component.html",
	styleUrls: ["./staff-digital-id-batch-mode.component.css"],
})
export class StaffDigitalIdBatchModeComponent implements OnInit {
	constructor(private dialogService: DialogService, private confirmationService: ConfirmationService, private idService: DataService_Staff_DigitalID) {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////

	@Output() EmailRefresh: EventEmitter<any> = new EventEmitter();

	Processing: boolean = false;

	@ViewChild(StaffDigitalIdBatchImportTableComponent)
	tableRef: StaffDigitalIdBatchImportTableComponent;

	ImportPreviewExpand: boolean = false;

	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////
	onImport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StaffDigitalIdBatchImportComponent, {
			header: "Digital ID Import",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			// console.log("Import Response");
			// console.log(response);

			if (response != "close") {
				this.tableRef.FormatOption = response[0];
				this.tableRef.ImportFileData = response[1];
				this.tableRef.loadPerson();

				this.ImportPreviewExpand = true;
			}
		});
	}

	onClearImportData() {
		this.errorMessage = "";

		this.tableRef.ClearData();
	}

	onDownloadImportTable() {
		this.errorMessage = "";

		if (this.tableRef.lstPerson.length == 0) {
			this.errorMessage = "No import data to download (Import preview table is empty)";
			return;
		}

		//
		// Pick Format
		//
		var ref = this.dialogService.open(StaffDigitalIdDownloadComponent, {
			header: "Select Format to Download",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != "close") {
				this.FinishDownload(response);
			}
		});
	}

	FinishDownload(FormatOption) {
		//
		// Text, Tab delimited
		//
		if (FormatOption.ID == 1) {
			this.DownloadImportTextTab();
		}
		//
		// Text, Commas
		//
		else if (FormatOption.ID == 2) {
			this.DownloadImportTextCommas();
		}
		//
		// CSV
		//
		else if (FormatOption.ID == 3) {
			this.DownloadImportCSV();
		}
	}

	DownloadImportTextTab() {
		var DataStr: string = "";

		for (var z = 0; z < this.tableRef.lstPerson.length; z++) {
			var next = this.tableRef.lstPerson[z];

			DataStr += next.StaffID;
			DataStr += "\t";
			DataStr += next.Email;
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/plain," + DataStr;
		a.download = FileName + ".txt";

		this.Processing = false;

		a.click(); //Downloaded file
	}

	DownloadImportTextCommas() {
		var DataStr: string = "";

		for (var z = 0; z < this.tableRef.lstPerson.length; z++) {
			var next = this.tableRef.lstPerson[z];

			DataStr += '"' + next.StaffID + '"';
			DataStr += ",";
			DataStr += '"' + next.Email + '"';
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/plain," + DataStr;
		a.download = FileName + ".txt";

		this.Processing = false;

		a.click(); //Downloaded file
	}

	DownloadImportCSV() {
		var DataStr: string = "";

		for (var z = 0; z < this.tableRef.lstPerson.length; z++) {
			var next = this.tableRef.lstPerson[z];

			DataStr += '"' + next.StaffID + '"';
			DataStr += ",";
			DataStr += '"' + next.Email + '"';
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/csv," + DataStr;
		a.download = FileName + ".csv";

		this.Processing = false;

		a.click(); //Downloaded file
	}

	onExport() {
		var ref = this.dialogService.open(StaffExportDigitalIdComponent, {
			header: "Export",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	onBatchEmail() {
		this.errorMessage = "";

		//
		// Check if any data was imported
		//
		if (this.tableRef.lstPerson.length == 0) {
			this.errorMessage = "Import a list of staff to email. NOTE: You can export a list, make changes to it and then re-import it";
			return;
		}

		//
		// Check if any of the data is valid
		//
		var lstValid: any = [];
		lstValid = Array.from(this.tableRef.lstPerson).filter((person: any) => person.ValidEntry == 1 && person.Email != "");

		if (lstValid.length == 0) {
			this.errorMessage = "No valid staff to email. Make sure the Staff IDs and emails are filled in correctly or import new data.";
			return;
		}

		this.ConfirmEmail(lstValid);
	}

	ConfirmEmail(lstValid) {
		var MSG = "You are about to send ";
		MSG += lstValid.length + " email(s). Do you want to continue?";

		this.confirmationService.confirm({
			key: "batch1",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Send Emails",
			icon: "fa",
			accept: () => {
				this.CheckValidActivations(lstValid);
			},
			reject: () => {},
		});
	}

	CheckValidActivations(lstValid) {
		var lstPIDs: number[] = [];

		for (var z = 0; z < lstValid.length; z++) {
			var next = lstValid[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: CheckValidActivationsRequest = {
			lstPersonIDs: lstPIDs,
		};

		var result = this.idService.EmailCheckValidActivations(parms);
		result.subscribe(
			(response: any) => {
				if (response.length == 0) {
					this.Processing = false;
				} else {
					//All selected schools have enough activations
					if (response[0].AllValid == true) {
						this.FinishEmail(lstValid);
					} else {
						var ref = this.dialogService.open(DigitalIdActivationInfoComponent, {
							header: "Not Enough Activations Left",
							width: "fit-content",
							data: {
								//INSERT Custom Data here
								lstTable: response,
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								this.FinishEmail(lstValid);
							} else {
								this.Processing = false;
							}
						});
					}
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	FinishEmail(lstValid) {
		this.Processing = true;

		//
		// Create Request
		//

		let lstStaffPersonID: number[] = [];
		let lstEmail: string[] = [];

		for (var z = 0; z < lstValid.length; z++) {
			var next = lstValid[z];

			lstStaffPersonID = [...lstStaffPersonID, next.PersonID];
			lstEmail = [...lstEmail, next.Email];
		}

		let parms: StaffRegisterManualEmailRequest = {
			lstPersonIDs: lstStaffPersonID,
			lstEmails: lstEmail,
		};

		var result = this.idService.RegisterEmail(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "batch2",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Batch email sent successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ImportPreviewExpand = false;
							this.EmailRefresh.emit(true);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "batch2",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send emails",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing;
	}
}
